import { all } from "redux-saga/effects";
import authenticationSaga from "./auth";
import SmsSaga from "./sms";

export default function* rootSaga() {
  yield all([...authenticationSaga, ...SmsSaga]);
}
